import {createSlice} from "@reduxjs/toolkit";

const initialSettingsState = {
  isLoading: true,
  webhooks: null,
  notification: null
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState: initialSettingsState,
  reducers: {
    // Webhook Responses
    settingsNotification: (state, action) => {
      state.notification = action.payload.notification;
    },

    // fetchWebhooks
    webhooksFetched: (state, action) => {
      state.isLoading = false;
      state.webhooks = action.payload.data;
    },

    // addWebhook
    webhookCreated: (state, action) => {
      state.notification = {type: "success", message: action.payload.data.message};
    },

    // updateWebhook
    webhookUpdated: (state, action) => {
      state.notification = {type: "success", message: "Webhook Updated Successful"};
      state.webhooks = state.webhooks.map(el => {
        return action.payload.data.id === el.id ? ({...el, ...action.payload.data}) : el;
      })
    },
    
    // deleteWebhook
    webhookDeleted: (state, action) => {
      state.notification = {type: "success", message: "Webhook Deleted Successful"};
      state.webhooks = state.webhhoks.filter(el => el.id !== action.payload.data.id);
    }
  }
});
